import React from 'react'

// ช่องกรอกข้อมูลของหน้าสร้าง / แก้ไขเอกสาร : label ด้านบน , span = จำนวนคอลัมน์ที่กินใน grid
// ต้องประกาศนอก component ของหน้า ไม่งั้น input จะถูกสร้างใหม่ทุกครั้งที่พิมพ์ (focus หลุด)
export default function Field({ label, required, span, children }) {
    return (
        <div className={span ? `nd-field nd-span-${span}` : 'nd-field'}>
            <label className='nd-label'>{label}{required && <span className='nd-req'> *</span>}</label>
            {children}
        </div>
    )
}
